export default __webpack_public_path__ + "static/media/G0360.ACS_algo_final_nov_22.1670416320000.8a6741b6.jpg";